// react
import React from 'react';
import { FormattedMessage } from 'react-intl';

// data stubs
import theme from '../../data/theme';

export default function FooterContacts() {
    return (
        <div className="site-footer__widget footer-contacts">
            <h5 className="footer-contacts__title">
                <FormattedMessage id="footer.contactUs" defaultMessage="Contact Us" />
            </h5>

            <ul className="footer-contacts__contacts">
                <li>
                    <i className="footer-contacts__icon fas fa-globe-americas" />
                    {theme.contacts.address}
                </li>
                <li>
                    <i className="footer-contacts__icon far fa-envelope" />
                    {theme.contacts.email}
                </li>
                {/* <li>
                    <i className="footer-contacts__icon fas fa-mobile-alt" />
                    {`${theme.contacts.phone}`}
                </li> */}
                {/* <li>
                    <i className="footer-contacts__icon far fa-clock" />
                    <FormattedMessage id="footer.workingHours" defaultMessage="Mon-Sat 10:00pm - 7:00pm" />
                </li> */}
            </ul>
        </div>
    );
}
